import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DatePicker, Input, Popconfirm } from 'antd';
import TableC from '../../../basicElement/TableC';
import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';

class EditableCell extends Component {
    handleInputChange = (e) => {
        this.props.onChange(e.target.value);
    }

    handleDateChange = (date, dateString) => {
        this.props.onChange(dateString);
    }
 
    getContent = () => {
        const { type, value, ...rest } = this.props;
        if (type === 'input') {
            return (
                <Input
                    value={value}
                    placeholder='请输入'
                    style={{ width: '100%' }}
                    onChange={this.handleInputChange}
                />
            );
        } else if (type === 'datePicker') {
            return (
                <DatePicker
                    {...rest}
                    placeholder='请选择'
                    style={{ width: '100%' }}
                    value={value ? moment(value) : null}
                    onChange={this.handleDateChange}
                />
            );
        }
    }

    render () {
        const { editable, value } = this.props;
        return (
            <div>
                {
                    editable ?
                        this.getContent()
                    :
                        value
                }
            </div>
        );
    }
}

class TokenActionOrPlan extends Component {
    static contextTypes = {
        systemDate: PropTypes.string
    };

    handleDelete = (index) => {
        const { data, onChange } = this.props;
        data.splice(index, 1);
        onChange(data);
    }

    handleChange = (value, key, index) => {
        const { data, onChange } = this.props;
        const target = data[index];
        target[key] = value;
        onChange(data);
    }

    disabledDate = (current) => {
        const { systemDate } = this.context;
        const value = moment(moment(systemDate).format(dateFormat)).add(1,'d').valueOf(); //  bug:30460
        return current && current.valueOf() >= value;
    }

    getColumns = () => {
        const { canEdit } = this.props;
        const columns = [{
            title: '措施/计划',
            dataIndex: 'planInfo',
            key: 'planInfo',
            width: 240,
            render: (text, record, index) => {
                return (
                    <EditableCell
                        editable={canEdit}
                        type='input'
                        value={text}
                        onChange={value => this.handleChange(value, 'planInfo', index)}
                    />
                );
            }
        }, {
            title: '计划完成时间',
            dataIndex: 'planFinishDateStr',
            key: 'planFinishDateStr',
            width: 120,
            render: (text, record, index) => {
                return (
                    <EditableCell
                        editable={canEdit}
                        type='datePicker'
                        value={text}
                        onChange={value => this.handleChange(value, 'planFinishDateStr', index)}
                    />
                );
            }
        }, {
            title: '责任人',
            dataIndex: 'responsibleUser',
            key: 'responsibleUser',
            width: 120,
            render: (text, record, index) => {
                return (
                    <EditableCell
                        editable={canEdit}
                        type='input'
                        value={text}
                        onChange={value => this.handleChange(value, 'responsibleUser', index)}
                    />
                );
            }
        }, {
            title: '实际完成时间',
            dataIndex: 'actuallyFinishDateStr',
            key: 'actuallyFinishDateStr',
            width: 120,
            render: (text, record, index) => {
                return (
                    <EditableCell
                        editable={canEdit}
                        type='datePicker'
                        value={text}
                        disabledDate={this.disabledDate}
                        onChange={value => this.handleChange(value, 'actuallyFinishDateStr', index)}
                    />
                );
            }
        }];
        if (canEdit) {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 60,
                render: (text, record, index) => {
                    return (
                        <Popconfirm title="确定删除该记录?" onConfirm={() => this.handleDelete(index)}>
                            <a>删除</a>
                        </Popconfirm>
                    );
                }
            });
        }
        return columns;
    }

    render() {
        const { data } = this.props;
        return (
            <TableC
                data={data}
                columns={this.getColumns()}
                scrollY={400}
            />
        );
    }
}

export default TokenActionOrPlan;


// WEBPACK FOOTER //
// ./src/components/qualityManagement/ComplaintRegistrationForm/components/TokenActionOrPlan.js